import { useEffect } from 'react';

import { driver as Driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';

import useWorkspaceNavigate from '@/hooks/useWorkspaceNavigate';

interface UseDriverProps {
  isLoading: boolean;
  steps: DriveStep[];
}

export const useDriver = ({ isLoading, steps }: UseDriverProps) => {
  const workspaceNavigate = useWorkspaceNavigate();

  useEffect(() => {
    const { hash, pathname, search } = window.location;

    if (hash && hash === '#demo' && !isLoading) {
      const driver = Driver({
        showProgress: true,
        disableActiveInteraction: true,
        steps,
        onDestroyed: () => {
          const relativePath = pathname.replace(/^\/workspace\/[^/]+/, '');

          workspaceNavigate(relativePath + search);
        }
      });

      driver.drive();
    }
  }, [isLoading, workspaceNavigate]);
};

export default useDriver;
